<template>
    <div class="rooms-list">
        <!-- Empty State -->
        <div v-if="!modelValue || modelValue.length === 0" class="empty-state congress-schedule-empty-state px-5">
            <p class="mb-4">{{ lang('congresses::congresses.accommodations.rooms.empty') }}</p>
            <Button type="button" size="sm" color="brand" variant="inline" @click="addRoom">
                <span class="action-icon">
                    <Icon icon="phosphor/regular/bed"></Icon>
                </span>
                <span class="action-label-text">
                    {{ lang('congresses::congresses.accommodations.rooms.add') }}
                </span>
            </Button>
        </div>

        <!-- Rooms List -->
        <div v-else>
            <Sortable :list="modelValue" item-key="_id" tag="div" class="space-y-2" @end="onReordered">
                <template #item="{ element: room, index }">
                    <RoomCard
                        :key="room._id"
                        v-model="modelValue[index]"
                        :accommodation-id="props.accommodationId"
                        :accommodation-index="props.accommodationIndex"
                        :room-index="index"
                        :available-tickets="props.availableTickets"
                        :accommodation-ticket-ids="props.accommodationTicketIds"
                        @remove="removeRoom(index)"
                    />
                </template>
            </Sortable>

            <div class="accommodation-room-list-after-actions">
                <Button type="button" size="sm" color="brand" variant="inline" @click="addRoom">
                    <span class="action-icon">
                        <Icon icon="phosphor/regular/bed"></Icon>
                    </span>
                    <span class="action-label-text">
                        {{ lang('congresses::congresses.accommodations.rooms.add') }}
                    </span>
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid';
import { lang } from '@/lang/composable';
import Sortable from '@src/Common/Components/Sortable.vue';
import Button from '@src/Common/Components/Button.vue';
import RoomCard from './RoomCard.vue';
import type { AccommodationRoom } from '../types';

interface Ticket {
    id: number;
    name: string;
}

const props = defineProps<{
    accommodationId: string;
    accommodationIndex: number;
    availableTickets?: Ticket[];
    accommodationTicketIds?: Ticket[];
}>();

const modelValue = defineModel<AccommodationRoom[]>({ default: () => [] });

const addRoom = () => {
    if (!modelValue.value) {
        modelValue.value = [];
    }
    modelValue.value = [
        ...modelValue.value,
        {
            _id: uuidv4(),
            name: '',
            description: '',
            price: '',
            currency: 'CZK',
            sort_order: modelValue.value.length,
            allow_roommates: true,
        },
    ];
};

const removeRoom = (index: number) => {
    if (confirm(lang('congresses::congresses.accommodations.rooms.confirm_remove'))) {
        modelValue.value = modelValue.value.filter((_, idx) => idx !== index);
    }
};

const onReordered = (event: { oldIndex: number; newIndex: number }) => {
    const items = [...modelValue.value];
    const [movedItem] = items.splice(event.oldIndex, 1);
    items.splice(event.newIndex, 0, movedItem);

    items.forEach((room, idx) => {
        room.sort_order = idx;
    });

    modelValue.value = items;
};
</script>
